export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "pulsebet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "pulsebet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
